import * as types from '../types'

/**
 * 团购数据
 * list: 团购列表
 * status: 团购状态
 * @type {Object}
 */
const state = {
    list: [
        {
            id: 1,
            name: '新疆原味瓜子 饱满香脆',
            thumbnail: 'good.png',
            farmer: '一米市集严选',
            spec: '157g',
            shop_price: '9.72',
            promote_price: '',
            promote_type: '',
            stock: '0'
        },
        {
            id: 2,
            name: '原味野生红松子',
            thumbnail: 'good.png',
            farmer: '科科美人',
            spec: '255g',
            shop_price: '68.00',
            promote_price: '54.40',
            promote_type: '新品',
            stock: '123'
        },
        {
            id: 3,
            name: '原味夏威夷果仁',
            thumbnail: 'good.png',
            farmer: '蓝袋鼠',
            spec: '160g',
            shop_price: '68.00',
            promote_price: '54.40',
            promote_type: '',
            stock: '123'
        },
        {
            id: 3,
            name: '新西兰草饲牛尾段',
            thumbnail: 'good.png',
            farmer: '一米市集严选',
            spec: '500g',
            shop_price: '68.00',
            promote_price: '54.40',
            promote_type: '',
            stock: '123'
        },
        {
            id: 4,
            name: '不停妈妈生的五彩蛋',
            thumbnail: 'good.png',
            farmer: '天爱庄园',
            spec: '10个',
            shop_price: '68.00',
            promote_price: '54.40',
            promote_type: '买一送一',
            stock: '123'
        },
        {
            id: 5,
            name: '新西兰银鳕 宝贝营养首选',
            thumbnail: 'good.png',
            farmer: ' Ocean Gala',
            spec: '150g',
            shop_price: '96.00',
            promote_price: '86.40',
            promote_type: '买一送一',
            stock: '123'
        },
        {
            id: 6,
            name: '山东红红富士',
            thumbnail: 'good.png',
            farmer: '山丘先生',
            spec: '12只',
            shop_price: '60.00',
            promote_price: '54.00',
            promote_type: '',
            stock: '123'
        }
    ],
    status: [
        {
            id: 1,
            name: '进行中'
        },
        {
            id: 2,
            name: '已完成'
        },
        {
            id: 3,
            name: '已取消'
        }
    ]
}

const getters = {

}

const mutations = {

}

const actions = {

}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/group.js